import $ from 'jquery';

class ReadingTime {
    constructor () {
        if($('#single-article-content-container')){
            this.textToEstimate = $('#single-article-content-container')[0].innerText;
            this.estimatedTimeInfo = $('#estimated-time-info')[0];
            this.events();
        };
    }

    events(){
        const wpm = 225;
        const words = this.textToEstimate.trim().split(/\s+/).length;
        const time = Math.ceil(words / wpm);
        this.estimatedTimeInfo.innerText = `${time} min`;
    }
    
}

export default ReadingTime;

